import React, { useState } from 'react'

export default function BankAccountWarning({proceed, cancel, saving}) {

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                    <div>
                        <p style={{marginBottom: "0px"}}><b>Disconnecting your account will have the following effect: </b></p>
                        <ol style={{listStylePosition: "inside", textAlign: "left"}}>
                            <li>
                                All payment links from this account will be disabled and removed from invoices
                            </li>
                            <li>
                                All active auto-pay associated to this account will be deactivated
                            </li>
                            <li>
                                All donation items associated to this account will be unsuable for new invoices
                            </li>
                            <li>
                                All pages using this account for Stripe payments will be detached and have payments turned off
                            </li>
                        </ol>
              </div>
                    <div className="pt-3">
                        <button onClick={proceed} type="button" className="btn btn-primary mr-2" disabled={saving}>
                            Proceed
                        </button>

                        <button onClick={cancel} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                            Cancel
                        </button>
                    </div>
                </div>
    </div>
    </div>
  )
}
